import React from 'react'
export default class ReservationBuilderBillingPolicy extends React.Component {

  constructor(props) {
    super(props);
    
    this.deposit_date = DateHelper.parseDate(this.props.reservation.deposit_date);
    this.balance_date = DateHelper.parseDate(this.props.reservation.balance_date);
    this.deposit_amount = this.props.reservation.deposit_amount;
    this.balance_amount = this.props.reservation.balance_amount;
    this.billing_policy = this.props.reservation.billing_policy;
    
    this.state = {
      open: this.props.open,
      customBillingPolicy: false,
      depositDate: this.deposit_date,
      balanceDate: this.balance_date,
      depositAmount: this.props.reservation.deposit_amount,
      balanceAmount: this.props.reservation.balance_amount,
      dateFormat: DateHelper.rubyToDateJS(this.props.date_format),
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
    };

    this.onChangeAmount = this.onChangeAmount.bind(this);
    this.onChangeBillingPolicy = this.onChangeBillingPolicy.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onOpen = this.onOpen.bind(this);
  };

  componentDidMount() {
    this.initDatepickers();
  }

  componentDidUpdate() {
    this.initDatepickers();
  }

  componentWillReceiveProps(nextProps) {    
    if (nextProps.reservation.total_amount != this.props.reservation.total_amount || nextProps.reservation.deposit_amount != this.state.depositAmount ||  nextProps.reservation.balance_amount != this.state.balanceAmount) {
      this.setState({
        depositAmount: nextProps.reservation.deposit_amount,
        balanceAmount: nextProps.reservation.balance_amount,
      });
    }

    this.billing_policy = nextProps.reservation.billing_policy;
    this.deposit_date = DateHelper.parseDate(nextProps.reservation.deposit_date);
    this.balance_date = DateHelper.parseDate(nextProps.reservation.balance_date);
    this.setState({
      depositDate: this.deposit_date,
      balanceDate: this.balance_date,
    });

    if (this.refs.deposit_date && this.refs.balance_date && $(this.refs.deposit_date).data('datepicker') && $(this.refs.balance_date).data('datepicker')) {
      $(this.refs.deposit_date).off('changeDate', this.onChangeDate).datepicker('setDate', this.deposit_date).on('changeDate', this.onChangeDate);
      $(this.refs.balance_date).off('changeDate', this.onChangeDate).datepicker('setDate', this.balance_date).on('changeDate', this.onChangeDate);
    }
  }

  initDatepickers() {
    if (!$(this.refs.deposit_date).data('datepicker') && !$(this.refs.balance_date).data('datepicker')) {
      var self = this;
      var today = DateHelper.current();
      var twoYearsFromToday = today.clone().add(2).years();
      var datepicker_opts = {
        forceParse: false, 
        maxViewMode: 0, 
        startDate: today, 
        endDate: twoYearsFromToday, 
        autoclose: true, 
        format: DateHelper.rubyToDatepicker(this.props.date_format),
        todayBtn: 'linked'
      };

      $(this.refs.deposit_date).datepicker(datepicker_opts).datepicker('setDate', this.state.depositDate);
      $(this.refs.balance_date).datepicker(datepicker_opts).datepicker('setDate', this.state.balanceDate);

      $(this.refs.deposit_date).on('changeDate', self.onChangeDate);
      $(this.refs.balance_date).on('changeDate', self.onChangeDate);
    }
  }

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <h3 className="panel-title pull-left">
            {this.renderArrow()}
            {I18n.t('billing_policy')}
          </h3>
          <div className="pull-right" style={{position: 'relative', top: 3, fontSize: 15}}>
            {
              this.state.customBillingPolicy || this.props.reservation.billing_policy == null 
              ? 
              <span>{I18n.t('custom')}</span> 
              : 
              <span>
                {/*this.props.reservation.billing_policy.name*/} 
                <select className="form-control input-sm" onChange={this.onChangeBillingPolicy} value={JSON.stringify(this.props.reservation.billing_policy)} style={{position: 'relative', top: -2, width: 'auto', display: 'inline-block', marginRight: 3}}>
                  {this.props.reservation.billing_policies.map((billing_policy) => {
                    return <option key={billing_policy.id} value={JSON.stringify(billing_policy)}>{billing_policy.name}</option>
                  })}
                </select>
                {this.renderBillingPolicyDescription()}
              </span>
            }
          </div>
          <div className="clearfix"></div>
        </div>
        <div className="panel-body" ref="body" style={{display: this.props.expandCollapse ? 'none' : 'block'}}>
          <h5 className="panel-heading-text">{I18n.t('deposit')}</h5>
          <div className="row">
            <div className="col-md-6">
              <label>{I18n.t('date_str')}</label>
              <div className="input-group">
                <input name="reservation[deposit_date]" ref="deposit_date" type="text" className="form-control datepicker no-auto-datepicker" defaultValue={this.state.depositDate.toString(this.state.dateFormat)} />
                <span className="input-group-addon"><span className="ss-calendar"></span></span>
              </div>
            </div>
            <div className="col-md-6">
              <label>{I18n.t('amount')}</label>
              <div className="input-group input-group-currency">
                <div className="input-group-addon">{I18n.t('number.currency.format.unit')}</div>
                <CurrencyInput name='reservation[deposit_amount]' ref="deposit_amount" value={this.state.depositAmount} className="form-control" data-min-length="0" min="0" max={this.props.reservation.total_amount} onChange={this.onChangeAmount} />
              </div>
            </div>
          </div>
          
          <hr />
          
          <h5 className="panel-heading-text">{I18n.t('balance')}</h5>
          <div className="row">
            <div className="col-md-6">
              <label>{I18n.t('date_str')}</label>
              <div className="input-group">
                <input name="reservation[balance_date]" ref="balance_date" type="text" className="form-control datepicker no-auto-datepicker" defaultValue={this.state.balanceDate.toString(this.state.dateFormat)} />
                <span className="input-group-addon"><span className="ss-calendar"></span></span>
              </div>
            </div>
            <div className="col-md-6">
              <label>{I18n.t('amount')}</label>
              <div className="input-group input-group-currency" style={{marginLeft: 0, marginRight: 0, paddingTop: 7}}>
                {I18n.t('number.currency.format.unit')}{numeral(this.state.balanceAmount / 100).format(this.state.numberFormat)}
              </div>
            </div>
          </div>

          {this.renderCancellationRules()}

        </div>
      </div>
    );
  }

  renderArrow() {
    if (this.props.expandCollapse) {
      if (this.state.open) {
        return (
          <div className="toggle-arrow arrow-down" onClick={this.onClose}></div>
        );
      } else {
        return (
          <div className="toggle-arrow arrow-right"  onClick={this.onOpen}></div>
        );      
      }
    }
  }

  renderBillingPolicyDescription() {
    if (this.props.reservation.billing_policy.terms && this.props.reservation.billing_policy.terms != '') {
      return (
        <span className="ss-help help" title={I18n.t('terms_and_conditions') + ': ' + this.props.reservation.billing_policy.terms}></span>
      );
    }
  }

  renderCancellationRules() {
    if (this.props.reservation.billing_policy && this.props.reservation.billing_policy.cancellation_rules && this.props.reservation.billing_policy.cancellation_rules.length) {
      var rules = this.props.reservation.billing_policy.cancellation_rules.map((cancellation_rule) => {
        return <li key={cancellation_rule.id}><CancellationRule read_only={true} {...cancellation_rule} /></li>
      });
      return (
        <div>
          <hr />
          <h5 className="panel-heading-text">{I18n.t('cancellation_rules')}</h5>
          <ul className="cancellation-rules">
            {rules}
          </ul>
        </div>
      );
    }
  }

  calculateDepositAmount(reservation) {
    var depositAmount = 0;
    var billingPolicy = reservation.billing_policy;

    if (billingPolicy) {
      if (billingPolicy.deposit_amount != null && !isNaN(billingPolicy.deposit_amount)) {
        depositAmount = billingPolicy.deposit_amount;
      } else if (billingPolicy.deposit_percentage != null && !isNaN(billingPolicy.deposit_percentage)) {
        depositAmount = reservation.total_amount * billingPolicy.deposit_percentage;
      } else if (billingPolicy.deposit_days != null && !isNaN(billingPolicy.deposit_days)) {
        var dailyAverageAmount = reservation.total_amount / reservation.number_of_nights;
        depositAmount = dailyAverageAmount * billingPolicy.deposit_days;
      }

      // safety check
      if (depositAmount < 0) {
        depositAmount = 0;
      } else if (billingPolicy.deposit_amount > reservation.total_amount) {
        depositAmount = reservation.total_amount;
      }  
    }

    return depositAmount;  
  }

  calculateBalanceAmount(reservation) {
    var depositAmount = this.calculateDepositAmount();
    var billingPolicy = reservation.billing_policy;

    balanceAmount = reservation.total_amount - depositAmount;

    // safety check
    if (balanceAmount < 0) {
      balanceAmount = 0;
    } else if (balanceAmount > reservation.total_amount) {
      balanceAmount = reservation.total_amount;
    }

    return balanceAmount;
  }

  onChangeAmount(event) { 
    var depositAmount = this.refs.deposit_amount.getValue();
    var balanceAmount = this.props.reservation.total_amount - depositAmount;
    var customBillingPolicy = (depositAmount != this.deposit_amount || balanceAmount != this.balance_amount);
    var reservation = this.props.reservation;

    if (depositAmount == 0) {
      depositAmount = '';
    }

    reservation.deposit_amount = this.state.depositAmount;
    reservation.balance_amount = this.state.balanceAmount;
    reservation.billing_policy = customBillingPolicy ? null : this.billing_policy;


    this.setState({depositAmount: depositAmount, balanceAmount: balanceAmount, customBillingPolicy: customBillingPolicy}, () => {
      ReservationBuilderActions.setValue('reservation', reservation);
    });
  }

  onChangeBillingPolicy (event) {
    ReservationBuilderActions.setBillingPolicy(JSON.parse(event.target.value));
  }

  onChangeDate() {
    var depositDate = $(this.refs.deposit_date).data('datepicker').getDate();
    var balanceDate = $(this.refs.balance_date).data('datepicker').getDate();
    var customBillingPolicy = (!depositDate.equals(DateHelper.parseDate(this.deposit_date)) || !balanceDate.equals(DateHelper.parseDate(this.balance_date)));
    var reservation = this.props.reservation;

    reservation.deposit_date = this.state.depositDate;
    reservation.balance_date = this.state.balanceDate;
    reservation.billing_policy = customBillingPolicy ? null : this.billing_policy;
        
    this.setState({depositDate: depositDate, balanceDate: balanceDate, customBillingPolicy: customBillingPolicy}, () => {
      ReservationBuilderActions.setValue('reservation', reservation);
    });
  }

  onClose() {
    var self = this;

    this.setState({open: false}, function () {
      $(self.refs.body).slideUp('fast');
    });
  }

  onOpen() {
    var self = this;

    this.setState({open: true}, function () {
      $(self.refs.body).slideDown('fast');
    });
  }

};